import { Lesson } from '@/models/Lesson';
import { LessonData } from '@/models/LessonData';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { CourseStudentView } from '../list/types';
import { StudentTypes } from './types';

export const addContentToCourseRequest = (lessonData: LessonData[], personId: number, courseId: number) =>
    action(StudentTypes.ADD_CONTENT_TO_COURSE_REQUEST, { lessonData, personId, courseId });
export const addContentToCourseSucess = () => action(StudentTypes.ADD_CONTENT_TO_COURSE_SUCCESS);
export const addContentToCourseFailure = (error: AxiosError) => action(StudentTypes.ADD_CONTENT_TO_COURSE_FAILURE, error);

export const deleteContentFromCourseRequest = (lessonId: number, personId: number, courseId: number) =>
    action(StudentTypes.DELETE_CONTENT_FROM_COURSE_REQUEST, { lessonId, personId, courseId });
export const deleteContentFromCourseSuccess = (lessonId: number) => action(StudentTypes.DELETE_CONTENT_FROM_COURSE_SUCCESS, { lessonId });
export const deleteContentFromCourseFailure = (error: AxiosError) => action(StudentTypes.DELETE_CONTENT_FROM_COURSE_FAILURE, error);

export const getAddedContentListRequest = (personId: number, courseId: number, ignoreLocale: boolean = false) =>
    action(StudentTypes.GET_ADDED_CONTENT_LIST_REQUEST, { personId, courseId, ignoreLocale });
export const getAddedContentListSuccess = (data: CourseStudentView) => action(StudentTypes.GET_ADDED_CONTENT_LIST_SUCCESS, { data });
export const getAddedContentListFailure = (error: AxiosError) => action(StudentTypes.GET_ADDED_CONTENT_LIST_FAILURE, error);
export const getAddedContentListClear = () => action(StudentTypes.GET_ADDED_CONTENT_LIST_CLEAR);

export const reorderContentListRequest = (lessonId: number, order: number) => action(StudentTypes.REORDER_CONTENT_LIST_REQUEST, { lessonId, order });
export const reorderContentListSuccess = (lessonId: number, order: number) => action(StudentTypes.REORDER_CONTENT_LIST_SUCCESS, { lessonId, order });
export const reorderContentListFailure = (error: AxiosError) => action(StudentTypes.REORDER_CONTENT_LIST_FAILURE, error);

export const setAddedContentList = (addedContentList: Lesson[]) => action(StudentTypes.SET_ADDED_CONTENT_LIST, addedContentList);
